import { TFunction } from "i18next";

import { type CheckFeatureFlag, Feature } from "@sol/features";
import { interpolate, Route } from "@sol/routing";
import { Brief } from "@sol/uikit/core/icons/Brief";
import { Calendar as CalendarIcon } from "@sol/uikit/core/icons/Calendar";
import { Clipboard } from "@sol/uikit/core/icons/Clipboard";
import { Home04 } from "@sol/uikit/core/icons/General/Home04";
import { Target04 } from "@sol/uikit/core/icons/General/Target04";
import { Resource } from "@sol/uikit/core/icons/Resource";
import { Work } from "@sol/uikit/core/icons/Work";

import { getLink, MenuItem } from "./getLink";

export const getLearnerMenuItems = ({
    t,
    checkFeatureFlag,
    classroomId,
}: {
    t: TFunction;
    checkFeatureFlag: CheckFeatureFlag;
    classroomId?: string;
}): MenuItem[] => {
    const items: MenuItem[] = [];

    if (checkFeatureFlag(Feature.MENU_HOME)) {
        items.push(
            getLink({
                "data-cy": "menu-item-home",
                href: Route.HOME,
                label: t("component.Navigation.Menu.items.home"),
                icon: <Home04 stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.MY_WORKSPACE)) {
        items.push(
            getLink({
                "data-cy": "menu-item-my-workspace",
                href: Route.MY_WORKSPACE,
                label: t("component.Navigation.Menu.items.myWorkspace"),
                icon: <Work stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.AGENDA)) {
        items.push(
            getLink({
                "data-cy": "menu-item-agenda",
                href: interpolate(Route.CLASSROOM_AGENDA, { classroomId }),
                label: t("component.Navigation.Menu.items.agenda"),
                icon: <CalendarIcon stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.BRIEFS_EXPLORE)) {
        items.push(
            getLink({
                "data-cy": "menu-item-briefs-explore",
                href: Route.BRIEFS_EXPLORE,
                label: t("component.briefs.BriefListPage.BriefsExplore.label"),
                icon: <Brief stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.CLASSROOM_LEARNER_PROGRESSION)) {
        items.push(
            getLink({
                "data-cy": "menu-item-progression",
                href: interpolate(Route.CLASSROOM_LEARNER_PROGRESSION, { classroomId }),
                label: t("component.Navigation.Menu.items.progression"),
                icon: <Target04 stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.MENU_FOLLOW_UPS)) {
        items.push(
            getLink({
                "data-cy": "menu-item-follow-ups",
                href: Route.FOLLOW_UPS_LIST,
                label: t("component.Navigation.Menu.items.followUp"),
                icon: <Clipboard stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    if (checkFeatureFlag(Feature.RESOURCES)) {
        items.push(
            getLink({
                "data-cy": "menu-item-resources",
                href: interpolate(Route.CLASSROOM_RESOURCES, { classroomId }),
                label: t("component.Navigation.Menu.items.classroomSpace.children.resources"),
                icon: <Resource stroke="transparent-base" className="rounded-none" />,
            }),
        );
    }

    return items;
};
